const palette = {
  colors: [
    '#45B2E8',
    '#D9540D',
    '#2CAB72',
    '#2C4BAB',
    '#EDDD02',
    '#E84545',
    '#E845CE',
    '#5FCEC9',
    '#E89F45',
    '#28E43F',
    '#B765C0',
    '#458AE8',
    '#AB2C2C',
    '#AB2C75',
    '#27E5FF',
    '#7168F2',
    '#FF932B',
    '#855D00',
    '#ACE845',
    '#1C91B4'
  ]
};

export default palette;